/* eslint-disable jira/filename-case */

import type { StoreState } from '../types.tsx';
import shallowEqual from '../utils/shallowEqual.tsx';

const updateMiddleware =
	<TState,>(storeState: StoreState<TState>) =>
	(next: Function) =>
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	(arg: any): undefined => {
		let output;
		const state = storeState.getState();
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		const nextState = next(state, arg, (out: any) => {
			output = out;
		});
		if (!shallowEqual(nextState, state)) {
			storeState.setState(nextState);
		}
		return output;
	};

export default updateMiddleware;
